import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    background-color: rgba(255, 255, 255, 1);
    padding: 22px 24px;
    line-height: 22px;
    color: rgba(64, 55, 57, 1);
    text-align: left;

    .content-title {
        font-family: 'Montserrat';
        font-size: 16px;
        letter-spacing: 0.03em;
    }

    .content-explain,
    .content-explain > div {
        font-family: 'Montserrat-Light';
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 0.04em;
    }
    .content-explain span { font-family: 'Montserrat-Light'; color: rgba(12, 183, 148, 1); }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridContent/Wrapper.js